import Axios from "axios";
import moment from "moment-timezone";

export default {
    namespaced: true,
    state: {
        result_list: [],
    },
    getters: {
        result_list: (state) => {
            const list = [];
            for (const r of state.result_list) {
                if (!r.result_time) {
                    r.result_time = "-";
                } else {
                    r.result_time = moment(r.result_time).format("LLL");
                }

                if (r.cate_id === 1) {
                    r.cate_name = "หวยลาว";
                } else {
                    r.cate_name = "-";
                }
                list.push(r);
            }
            return list;
        },
    },
    mutations: {
        SET_RESULT_LIST(state, data) {
            state.result_list = data;
        },
        CLEAR_LIST(state) {
            state.result_list = [];
        },
    },
    actions: {
        async getResults({ commit }, date) {
            commit("CLEAR_LIST");
            const { data } = await Axios.get("/lotto-results?date=" + date);

            if (data.success && data.success === true) {
                commit("SET_RESULT_LIST", data.data);
            }
            return data;
        },

        async getTodayResults({ commit }) {
            commit("CLEAR_LIST");
            const { data } = await Axios.get("/lotto-results/today");

            if (data.success && data.success === true) {
                commit("SET_RESULT_LIST", data.data);
            }
            return data;
        },

        async getWaitinResults({ commit }) {
            commit("CLEAR_LIST");
            const { data } = await Axios.get("/lotto-results/waiting");

            if (data.success && data.success === true) {
                commit("SET_RESULT_LIST", data.data);
            }
            return data;
        },

        async updateResult(context, r_id) {
            const { data } = await Axios.put(
                "/lotto-results/" + r_id + "/change-result"
            );

            return data;
        },
    },
};
